// extracted by mini-css-extract-plugin
export default {"paymentSection":"j8-z","disabled":"k8-z"};